<template>
	<div class="enterprisewebsite" v-title :data-title="msg" data="informationdetail">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="heightVh95 whitebox container-flex-center">
					<freeUserTips :type="4" :bgtype="0" isShowPageTitle="资讯详情"></freeUserTips>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'newsdetail',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			msg: "",
			pagetypes: 1,
			curindex: 7,
			newsid: 1,
			hotlist: [],
			hotpolicy: [],
			pageextend: { policyDecode: [], policySource: [] },
			pagedata: { star: 0, content: "", notion: '', publishTime: "", keylist: [] },
			title: "", relatednews: [],
			userdata: {},
		}
	},
	created() {
		 
	},
	mounted() { },
	methods: {
		//添加删除收藏
		collectFun() {
			// console.log(this.companyinfor.collectId,this.companyinfor);
			this.listToggleCollect(this.pagedata, 'acoc');
		},
		getrelatednews(enterpriseid) {
			var ajaxurl = this.$api.cyl.enterprisenews.list() + '?date=month&stockCode=' + enterpriseid + '&page=1';
			var _this = this;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log(ajaxurl)
				console.log('获取相关企业资讯列表', res.data)
				if (res.data.success) {
					_this.relatednews = res.data.list.filter(list => {
						return list.id != _this.newsid;
					});
					_this.bus.$emit('loading', false);
					//  _this.totalPage = res.data.totalPage;
					//  _this.pageSize = res.data.pageSize;
					//  _this.total = res.data.totalRecord; 
					// _this.bus.$emit('loading', false); 
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});


		},
		getnewsdetail() {
			var _this = this;
			console.log(this.$api.cyl.enterprisenews.detail() + '?id=' + this.newsid)
			this.$axios.get(this.$api.cyl.enterprisenews.detail() + '?id=' + this.newsid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// 11-9 资讯详情页数据
				// console.log(res.data );
				_this.pagedata = res.data.data;
				console.log(res.data.data);
				document.title = res.data.data.title;
				_this.title = res.data.data.title;
				_this.getrelatednews(res.data.data.stockCode);
				// _this.bus.$emit('loading',false);
				// _this.chainnodelist=; 
			})
		},
		getpagelist() {
			var _this = this;
			this.$axios.get(this.$api.cyl.OCNNews.detail() + '?id=' + this.newsid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// 11-9 稍微有点数据
				console.log(res.data);
				_this.pagedata = res.data.data;
				// _this.pageextend=res.data.extend;
				if (res.data.extend != null) {
					_this.pageextend.policyDecode = res.data.extend.policyDecode == undefined ? [] : res.data.extend.policyDecode;
					_this.pageextend.policySource = res.data.extend.policySource == undefined ? [] : res.data.extend.policySource;
					// console.log(_this.pageextend.policySource,_this.pageextend.policyDecode);
					// console.log(res.data.extend.policySource,res.data.extend.policyDecode);
				};
				_this.pagedata.content = _this.pagedata.content.replace(new RegExp('<p><br/></p>', 'g'), '');
				_this.pagedata.keylist = _this.taglistfun(_this.pagedata.keywordsText, _this.pagedata.keywords);
				// console.log();
				_this.hotlist = res.data.list;
				document.title = res.data.data.title;
				_this.title = res.data.data.title;
				_this.bus.$emit('loading', false);
				// _this.chainnodelist=; 
			})
		},
		getpolicylist() {
			var _this = this;
			var ajaxurl = this.$api.cyl.news.list() + "?type=2&bigClass=30008";
			this.$axios.get(ajaxurl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// console.log("政策链",res);
				if (res.data.code < 1) {
					_this.hotpolicy = res.data.list;
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		}
	}
}



</script>

<style scoped="scoped">
.leftconbox {
	min-height: 840px;
}
</style>
